import React from 'react';
import './WebformInfoPage.less';
import {processTranslationReplaceAll} from '../utils/commonUtil';
import {CONTACT_PHONE_NUMBER} from '../../utils/constants';
import backgroundImage from "../../images/cabin-blue-create-account-page.svg";


export default class WebformInfoPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    webformInfoPageHeader() {
        const {translations} = this.props;
        return processTranslationReplaceAll(translations['ipmob.ineligible_page.heading_5'], [this.props.brandName]);
    }

    webformInfoPageContent() {
        const {translations} = this.props;
        return processTranslationReplaceAll(translations['ipmob.ineligible_page.content_9'], [this.props.brandName, CONTACT_PHONE_NUMBER]);
    }

    webformInfoPage() {
        return (<div className="page_content">
            <div className="panel-head">
                <h1 className="header"> {this.webformInfoPageHeader()}</h1>
            </div>
            <div className="helpful-resources-wrapper">
                <div className="webinfocontent-pg-desc">
                    <p>{this.webformInfoPageContent()}</p>
                </div>
            </div>
        </div>);
    }

    render() {
        return (<div className="webinfo-pg">
            <div className="webinfo-pg-wrapper container">
                <img className="webinfo-pg-bg-img" src={backgroundImage()}/>
                {this.webformInfoPage()}
            </div>
        </div>);
    }

}
